import { render, staticRenderFns } from "./PanCancer.vue?vue&type=template&id=b555036a&scoped=true&"
import script from "./PanCancer.vue?vue&type=script&lang=js&"
export * from "./PanCancer.vue?vue&type=script&lang=js&"
import style0 from "./PanCancer.vue?vue&type=style&index=0&id=b555036a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b555036a",
  null
  
)

export default component.exports